import React from 'react';

const Voucher = ({ rutaImagen, onDelete, onEdit }) => {
  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {/* Imagen del voucher */}
      <img 
        src={rutaImagen} 
        alt="voucher" 
        style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: '8px' }} 
      />
      
      {/* Botones flotantes */}
      <div style={{
        position: 'absolute',
        bottom: '20px',
        right: '20px',
        display: 'flex',
        gap: '10px',
        zIndex: 9999
      }}>
        <button 
          onClick={onEdit}
          style={{
            backgroundColor: '#ffc107',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer',
            color: '#000',
            fontWeight: 'bold'
          }}
        >
          ✏️ Editar
        </button>
        <button 
          onClick={onDelete}
          style={{
            backgroundColor: '#dc3545',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer',
            color: '#fff',
            fontWeight: 'bold'
          }}
        >
          🗑️ Eliminar
        </button>
      </div>
    </div>
  );
};

export default Voucher;